import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

// This history for action when want to redirect but not in react component (ex: redux, services, ...)
export default history;
